import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import language from '../../../js/stores/language.js';
import carPricing from '../../../js/stores/car-pricing.js';
function framework7Component(props, _ref) {
  var $h = _ref.$h,
    $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var saveCarPricing = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var formCarPricing, result;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            formCarPricing = $f7.form.convertToData('#car-pricing-form');
            _context2.next = 1;
            return carPricing.dispatch('modifyData', formCarPricing);
          case 1:
            result = _context2.sent;
            if (!(result.status !== undefined && result.status !== 200)) {
              _context2.next = 2;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context2.abrupt("return");
          case 2:
            if (Number(result) > 0) {
              $f7.toast.show({
                text: 'Option updated'
              });
            } else {
              console.log("Option not updated");
            }
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function saveCarPricing() {
      return _ref3.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="popup car-pricing-popup">
  <div class="view">
    <div class="page">
      <div class="navbar">
        <div class="navbar-bg"></div>
        <div class="navbar-inner">
          <div class="title">${locale.translate('car.edit.carSize')}: ${locale.translate(`general.sizeList[${props.CarSizeIndex}]`)}</div>
          <div class="right">
            <a class="link popup-close">
              <i class="icon material-symbols-outlined color-red">cancel</i>
            </a>
          </div>
        </div>
      </div>
      <div class="page-content">
        <div class="block-title">${locale.translate('general.edit')} ${locale.translate('car.edit.carSize')}</div>
        <div class="block block-strong">
          <form id="car-pricing-form" class="list">
            <input id="car-pricing-id" name="CarPricingId" type="hidden" value="${props.CarPricingId}" />
            <ul>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div id="" class="item-title item-label">${locale.translate('car.edit.carMinPrice')}</div>
                    <div id="label" class="item-title item-label"></div>
                    <div class="item-input-wrap">
                      <input id="car-min-price" name="CarMinPrice" type="number" value="${props.CarMinPrice}" placeholder="" autocomplete="off"/>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${locale.translate('car.edit.carMaxPrice')}</div>
                    <div class="item-input-wrap">
                      <input id="car-max-price" name="CarMaxPrice" type="number" value="${props.CarMaxPrice}" placeholder="" autocomplete="off"/>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${locale.translate('car.edit.minRecommendedPrice')}</div>
                    <div class="item-input-wrap">
                      <input id="min-recommended-price" name="MinRecommendedPrice" value="${props.MinRecommendedPrice}" type="number" placeholder="" autocomplete="off"/>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${locale.translate('car.edit.maxRecommendedPrice')}</div>
                    <div class="item-input-wrap">
                      <input id="max-recommended-price" name="MaxRecommendedPrice" type="number" value="${props.MaxRecommendedPrice}" placeholder="" autocomplete="off"/>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </form>
          <br />
          <div>
            <a href="#" class="button button-fill button-raised color-blue" @click="${saveCarPricing}">
              <span class="material-symbols-outlined">save</span>${locale.translate('general.save')}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`
    }
    ;
}
framework7Component.id = 'a8190b8933';
export default framework7Component;